import { render } from "./Video.vue?vue&type=template&id=4e3bb757"
const script = {}

import "./Video.vue?vue&type=style&index=0&id=4e3bb757&lang=css"

import exportComponent from "/Users/isamu/ss/web3/laidbacklu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__